import React from 'react';
import { Frown } from 'react-feather';
import styled from 'styled-components';
import { Colors } from 'app/seedly-component-library';

const Container = styled.div`
  text-align: center;
  padding-top: 50px;
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: ${props => props.theme.colors.neutral5};
  margin-top: 18px;
`;

const EmptySearchList = () => {
  return (
    <Container>
      <Frown size={106} color={Colors.neutral5} />
      <ErrorMessage>Try using another search term?</ErrorMessage>
    </Container>
  );
};

export default EmptySearchList;
